import { call, put, takeLatest } from 'redux-saga/effects';
import axios from "axios";
import uuidv1 from 'uuid';
import {
  REPORT_LOAD_DATA,
  REPORT_DOWNLOAD_RESULT_REQUEST,
  REPORT_LOAD_DATA_CANCELED,
  CANCEL_REPORT_REQUEST,
  SWITCH_TO_ASYNC_REPORT_REQUEST,
  SWITCH_TO_ASYNC_ENABLED_REQUEST,
  CANCEL_REPORT_ENABLED_REQUEST,
} from '../actions/types/ReportActionTypes';
import {
  reportLoadDataFailure,
  reportLoadDataSuccess,
  fetchDownloadReportResultSuccessActionCreator,
  fetchDownloadReportResultFailureActionCreator,
  cancelReportSuccessActionCreator,
  cancelReportFailureActionCreator,
  switchToAsyncReportSuccessActionCreator,
  switchToAsyncReportFailureActionCreator,
  switchToAsyncEnabledSuccessActionCreator,
  switchToAsyncEnabledFailureActionCreator,
  cancelReportEnabledSuccessActionCreator,
  cancelReportEnabledFailureActionCreator,
} from '../actions/ReportsActions';
import reportAPI from '../../api/ReportAPI';
import reportsAPI from '../api/ReportsAPI';
import { getDownloadFailureMessage } from '../../ReportDownloadMessages';
import { showErrorNotification } from '../../../../../core/modules/common/redux/actions/NotificationActions';
import { createRequestId } from '../../../../wizard/common/redux/actions/SelectionCriteriaWizardActions';

// eslint-disable-next-line prefer-destructuring
const CancelToken = axios.CancelToken;
let source;

export const USER_CANCEL_MESSAGE = 'Api is being canceled';

function* getReportWorker(action) {
  const {
    reportDefinition,
    mainReportId,
    requestParams,
  } = action.payload;
  const params = { ...requestParams };
  const createReqId = uuidv1();
  const reportCode = reportDefinition.id;
  params.reportCode = reportCode;
  params.requestId = createReqId;
  yield put(createRequestId(createReqId));
  try {
    const direction = reportDefinition.reportDirections.length === 1 ? reportDefinition.reportDirections[0] : params.direction;
    source = CancelToken.source();
    // eslint-disable-next-line prefer-destructuring
    const token = source.token;
    const result = yield call(
      reportDefinition.dataProvider,
      {
        ...params,
        direction,
        token,
      },
    );
    yield put(reportLoadDataSuccess(reportDefinition, mainReportId, result.data, params));
  } catch (error) {
    // eslint-disable-next-line no-empty
    if (axios.isCancel(error)) {
    } else {
      // eslint-disable-next-line no-lonely-if
      if (error.response) {
        yield put(reportLoadDataFailure(reportDefinition, mainReportId, error));
      }
    }
  }
}

function* fetchDownloadReportResultWorker(action) {
  try {
    const {
      reportName,
      execId,
      batchNo,
    } = action.payload;
    const response = yield call(
      reportAPI.getDownloadReportResult,
      reportName,
      execId,
      batchNo,
    );

    yield put(fetchDownloadReportResultSuccessActionCreator(response.data, action.payload));
  } catch (error) {
    yield put(fetchDownloadReportResultFailureActionCreator(error, action.payload));
    if (!(axios.isCancel(error) && error.message === USER_CANCEL_MESSAGE)) {
      yield put(showErrorNotification(getDownloadFailureMessage(error)));
    }
  }
}

function canceled() {
  source.cancel(USER_CANCEL_MESSAGE);
}

function* cancelReportRequest(action) {
  try {
    const cancelReportResponse = yield call(reportsAPI.cancelReportRequest, action.payload);
    const cancelReport = cancelReportResponse.data;
    const errorMessage = cancelReport.message;
    const modifiedErrMsg = errorMessage.split(': ')[1];

    yield put(cancelReportSuccessActionCreator(cancelReport));
    if (errorMessage !== 'CANCEL_OK') {
      yield put(showErrorNotification(modifiedErrMsg));
    }
  } catch (e) {
    yield put(cancelReportFailureActionCreator(e));
  }
}

function* switchToAsyncReportRequest(action) {
  try {
    const cancelReportResponse = yield call(reportsAPI.switchToAsyncReportRequest, action.payload);
    const cancelReport = cancelReportResponse.data;
    // eslint-disable-next-line no-unused-vars
    const errorMessage = cancelReport.message;
    // const modifiedErrMsg = errorMessage.split(': ')[1];

    yield put(switchToAsyncReportSuccessActionCreator(cancelReport));
  } catch (e) {
    yield put(switchToAsyncReportFailureActionCreator(e));
  }
}

function* switchToAsyncEnabledRequest(action) {
  try {
    const enabledResponse = yield call(reportsAPI.switchToAsyncEnabled, action.payload);

    yield put(switchToAsyncEnabledSuccessActionCreator(enabledResponse.data));
  } catch (e) {
    yield put(switchToAsyncEnabledFailureActionCreator(e));
  }
}

function* cancelReportEnabledRequest(action) {
  try {
    const enabledResponse = yield call(reportsAPI.cancelReportRequestEnabled, action.payload);

    yield put(cancelReportEnabledSuccessActionCreator(enabledResponse.data));
  } catch (e) {
    yield put(cancelReportEnabledFailureActionCreator(e));
  }
}

function* getReportWatcher() {
  yield takeLatest(REPORT_LOAD_DATA, getReportWorker);
  yield takeLatest(REPORT_DOWNLOAD_RESULT_REQUEST, fetchDownloadReportResultWorker);
  yield takeLatest(REPORT_LOAD_DATA_CANCELED, canceled);
  yield takeLatest(CANCEL_REPORT_REQUEST, cancelReportRequest);
  yield takeLatest(SWITCH_TO_ASYNC_REPORT_REQUEST, switchToAsyncReportRequest);
  yield takeLatest(SWITCH_TO_ASYNC_ENABLED_REQUEST, switchToAsyncEnabledRequest);
  yield takeLatest(CANCEL_REPORT_ENABLED_REQUEST, cancelReportEnabledRequest);
}

export default getReportWatcher;
